import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import * as S from './Loading.style';

const Loading = () => {
  const navigate = useNavigate();
  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
  }: any = useContext(LoadingContext);

  const handleBtn = () => {
    setLoading(false);
    setLoadingBtn('');
    setLoadingMensagem('');
    if (loadingAction) {
      const action = loadingAction;
      setLoadingAction(null);
      navigate(action);
    }
  };

  if (!loading) {
    return null;
  }

  return (
    <S.Container>
      {loadingMensagem && <S.TextLabel>{loadingMensagem}</S.TextLabel>}
      {!loadingBtn && (
        <S.ContainerLoading>
          <S.ContainerRing />
          <S.ContainerRing />
          <S.ContainerRing />
          <S.ContainerRing />
        </S.ContainerLoading>
      )}
      {loadingBtn && (
        <S.Button
          onClick={() => {
            handleBtn();
          }}
        >
          {loadingBtn}
        </S.Button>
      )}
    </S.Container>
  );
};

export default Loading;
